const observeContactFormAppearance = () => {

    const observer = new MutationObserver((mutations) => {
        const value = window.voFinancialSimulationSummaryValue;
        // Si l'on n'a pas encore effectué de simulation, on n'observe pas
        if(typeof value === 'undefined') {
            return;
        }

        mutations.forEach((mutation) => {
            const hiddenInput = document.querySelectorAll('input[name="details-simulation"]');
            if(hiddenInput.length > 0) {
                hiddenInput.forEach((element) => {
                    element.value = value;
                });
            }
        })
    });

    observer.observe(document.body, {
        childList: true,
        substree: true
    });
}

observeContactFormAppearance();